import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

import type { QueryParams } from '@/utils/queryParams'

type Props = {
  portfolioId: string
  query: QueryParams
}

export const useGetPortfolioGantt = ({ portfolioId, query }: Props) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['portfolioGantt', portfolioId, query],
    queryFn: () =>
      projectService.portfolio.getPortfolioGantt({
        portfolioId,
        query,
      }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar o gantt do portfólio',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      portfolioGantt: data,
      isLoading,
      refetchPortfolioGantt: refetch,
      isError,
    }
  }

  return {
    portfolioGantt: null,
    refetchPortfolioGantt: refetch,
    isLoading,
    isError,
  }
}
